<button (click)="internClick()" [class.tiny]="tiny" fxLayout="row" fxLayoutAlign="center center">
  <i [class]="icon"></i>
</button>
